import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";
import { setNotificationMessage } from "../home/action";
import { loaderFlag, setPopUpMessageData } from "../jobs/action";

import { setAllCityData, setAllStateData, setCertificateData, setCityData, setContractorReport, setCountryData, setCountryReportData, setExcelReport, setIntervalId, setLoaderFlag, setReportDealer, setReportValidation, setSearchCertificateData, setStateData } from './action';
import {
    GET_ALL_CITY_DATA,
    GET_ALL_STATE_DATA,
    GET_CERTIFICATE_DATA,
    GET_CONTRACTOR_REPORT_DATA,
    GET_COUNTRY_DATA,
    GET_EXCEL_REPORT,
    GET_REPORT_DEALER_DATA,
    GET_REPORT_VALIDATION,
    GET_SELECTED_STATE_CITY_DATA,
    SEARCH_CERTIFICATE_DATA,
} from './types';

const { createLogic } = require("redux-logic");

const reportValidation = createLogic({
    type: GET_REPORT_VALIDATION,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken, ...action?.payload?.payload }
        Service({
            method: "post",
            url: API_ROUTES.VALIDATION_REPORT,
            data: payload,
        })
            .then((res) => {
                if (res?.data?.error) {
                    dispatch(setPopUpMessageData({ modal: true, message: [res?.data?.error?.errorMsg] }))
                } else if (res?.data?.data) {
                    dispatch(setPopUpMessageData({ modal: true, message: [res?.data?.data?.message] }))
                    dispatch(setReportValidation(res?.data?.data?.success))
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getExcelReportData = createLogic({
    type: GET_EXCEL_REPORT,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const { reportType } = action.payload?.payload;
        const payload = { authToken, ...action.payload?.payload };
        if (reportType) {
            Service({
                method: "post",
                url: API_ROUTES.GET_REPORT,
                data: payload,
            })
                .then((res) => {
                    dispatch(setExcelReport(res?.data?.data));
                    done();
                })
                .catch((err) => {
                    dispatch(setExcelReport({}));
                    dispatch(setReportValidation(false));
                    dispatch(setIntervalId({}))
                    clearInterval(action?.payload?.intervalId)
                    dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                    done();
                });
        }
    },
});

const getCountryData = createLogic({
    type: GET_COUNTRY_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken, ...action?.payload?.payload }
        dispatch(setLoaderFlag(true))
        Service({
            method: "post",
            url: API_ROUTES.GET_ANNUAL_REPORT_LIST(action?.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setCountryData(res?.data?.data))
                }
                dispatch(setLoaderFlag(false))
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                dispatch(setLoaderFlag(false))
                done();
            });
    },
});

const getStateData = createLogic({
    type: GET_ALL_STATE_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken, ...action?.payload?.payload }
        // const payload = { authToken: authToken ? authToken : "", type: action.payload.type, userId: action.payload.userId, state: "", city: "" };
        dispatch(setLoaderFlag(true))
        Service({
            method: "post",
            url: API_ROUTES.GET_ANNUAL_REPORT_LIST((action.payload?.pageNo)),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setAllStateData(res?.data?.data))
                }
                dispatch(setLoaderFlag(false))
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                dispatch(setLoaderFlag(false))
                done();
            });
    },
});

const getCityData = createLogic({
    type: GET_ALL_CITY_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken: authToken ? authToken : "", type: action.payload.type, userId: action.payload.userId, state: action.payload.state };
        Service({
            method: "post",
            url: API_ROUTES.GET_COUNTRY_DATA_API((action.payload?.pageNo)),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setAllCityData(res?.data?.data))
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getSelectedStateCityData = createLogic({
    type: GET_SELECTED_STATE_CITY_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken: authToken ? authToken : "", id: action.payload?.id };
        Service({
            method: "post",
            url: API_ROUTES.GET_SELECTED_STATE_CITY_PIN,
            data: payload,
        })
            .then((res) => {

                switch (action.payload?.type) {
                    case "Country":
                        dispatch(setCountryReportData(res?.data?.data || {}))
                        break;

                    case "State":
                        dispatch(setStateData(res?.data?.data || {}))
                        break;

                    case "City":
                        dispatch(setCityData(res?.data?.data || {}))
                        break;

                    default:
                        break;
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});


const getDealerStateData = createLogic({
    type: GET_REPORT_DEALER_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        let payload = { authToken, ...action.payload?.payload }
        Service({
            method: "post",
            url: API_ROUTES.GET_ANNUAL_REPORT_LIST(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setReportDealer(res?.data?.data))
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getContractorReportData = createLogic({
    type: GET_CONTRACTOR_REPORT_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        let payload = { authToken, ...action.payload?.payload }
        Service({
            method: "post",
            url: API_ROUTES.GET_ANNUAL_REPORT_LIST(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setContractorReport({ data: res?.data?.data, type: action.payload?.payload?.userType }))
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});


const getCertificateData = createLogic({
    type: GET_CERTIFICATE_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        dispatch(loaderFlag(true))
        let payload = { authToken, ...action.payload?.payload, format: "PDF" }
        Service({
            method: "post",
            url: API_ROUTES.GET_CERTIFICATES_API(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setCertificateData({ data: res?.data?.data }))
                    dispatch(loaderFlag(false))
                }
                done();
            })
            .catch((err) => {
                dispatch(loaderFlag(false))
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const searchCertificateDataLogic = createLogic({
    type: SEARCH_CERTIFICATE_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken, ...action.payload?.payload };
        Service({
            method: "post",
            url: API_ROUTES.SEARCH_REPORTS(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                dispatch(setSearchCertificateData(res?.data?.data))
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});



export default [
    reportValidation, getExcelReportData, searchCertificateDataLogic,
    getCountryData, getStateData, getCityData, getSelectedStateCityData, getDealerStateData, getContractorReportData, getCertificateData
];



